/*
  LAMIXO held cart items (21 Oct 2026). When a shopper checks out only some
  of the cart (cart page selection, assets/lamixo-cart.js), the unselected
  items are taken out before checkout and kept in localStorage. This puts
  them back on the next storefront page, so they stay in the cart.
*/
(function () {
  var K = 'lmxCartHold', h = null;
  try { h = JSON.parse(localStorage.getItem(K) || 'null'); } catch (e) { return; }
  if (!h || !h.items || !h.items.length) return;
  try { localStorage.removeItem(K); } catch (e) {}
  if (Date.now() - (h.t || 0) > 30 * 864e5) return;
  var chain = Promise.resolve();
  h.items.forEach(function (it) {
    /* 21 Oct 2026: an item with no line properties was held as
       properties: [] (Liquid's json of an empty hash) and /cart/add.js
       rejects that with 400 "expected Array to be a Hash", so held items
       were silently lost. Only a real, non-empty hash is sent now. */
    var line = { id: it.id, quantity: it.quantity || 1 };
    var p = it.properties;
    if (p && typeof p === 'object' && !Array.isArray(p) && Object.keys(p).length) line.properties = p;
    chain = chain.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [line] })
      }).then(function (r) {
        /* not enough stock for the full quantity: keep at least one */
        if (r.status === 422 && line.quantity > 1) {
          line.quantity = 1;
          return fetch('/cart/add.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [line] })
          });
        }
      }).catch(function () {});
    });
  });
  chain.then(function () {
    if (/^\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (c) {
      if (window.LMXQA && window.LMXQA.setBadge) { window.LMXQA.setBadge(c.item_count); return; }
      var b = document.querySelector('.lmxh a[href="/cart"] b');
      if (b) b.textContent = c.item_count;
    });
  }).catch(function () {});
})();
